export enum BiskTransactionType {
    BUY = 'Buy',
    WITHDRAW = 'Withdraw',
    SEND = 'Send',
    SEND_TO_OBJECT = 'Send To Object',
    REDEEM = 'Redeem',
    REDEEM_FOR_OBJECT = 'Redeem For Object',
    AWARD = 'Award',
}